const MIME_TYPE_EXTENSIONS: Record<string, string> = {
  'application/json': 'json',
  'application/pdf': 'pdf',
  'application/vnd.android.package-archive': 'apk',
  'image/gif': 'gif',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'text/plain': 'txt',
  'video/mp4': 'mp4',
  'video/webm': 'webm',
};

function normalizeMimeType(contentType?: string | null): string | null {
  if (!contentType) {
    return null;
  }

  return contentType.split(';')[0]?.trim().toLowerCase() || null;
}

export function getMimeTypeExtension(
  contentType?: string | null,
): string | null {
  const normalizedContentType = normalizeMimeType(contentType);
  if (!normalizedContentType) {
    return null;
  }

  return MIME_TYPE_EXTENSIONS[normalizedContentType] || null;
}
